export default __webpack_public_path__ + "static/Nestify_logo-449e2117f56cc724c6ae492ec5db6301.png";